import { Loader2 } from "lucide-react";
import type { ComponentProps } from "react";
import { Button } from "@/components/ui/button";
import { useGetStarted } from "@/features/marketing/use-get-started";

type GetStartedButtonProps = Omit<ComponentProps<typeof Button>, "onClick" | "type">;

export function GetStartedButton({ children = "Get Started", disabled, ...props }: GetStartedButtonProps) {
  const { startGetStarted, busy } = useGetStarted();

  return (
    <Button
      type="button"
      disabled={disabled || busy}
      onClick={() => void startGetStarted()}
      {...props}
    >
      {busy ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          {children}
        </>
      ) : (
        children
      )}
    </Button>
  );
}
